import type { FC } from 'react';

import { SwitchContainer, Thumb } from './styled';
import type { SwitchProps } from './types';

export const Switch: FC<SwitchProps> = ({
	checked,
	onChange,
	disabled = false,
	size = 'small',
	name,
}) => {
	return (
		<SwitchContainer
			type="button"
			name={name}
			disabled={disabled}
			checked={checked}
			size={size}
			onClick={() => !disabled && onChange(!checked)}
		>
			<Thumb checked={checked} size={size} />
		</SwitchContainer>
	);
};
